export default __webpack_public_path__ + "static/media/set_1_Promo.a796b18c.svg";